import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'InputMultiselect',
  directives: {
    onClickaway: onClickaway
  },
  props: {
    value: { type: [Array, Object, String, Number, null], default: null },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    list: { type: Array, default: () => [] },
    itemValue: { type: String, default: 'id' },
    itemTitle: { type: String, default: 'title' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      isOpen: false,
      selectedData: []
    };
  },

  created() {},
  mounted() {},
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectedData = this._normalizeValue(newVal);
      }
    }
  },
  computed: {
    options() {
      let selectedIds = new Set(this.selectedData.map((item) => item[this.itemValue]));

      return this.list.map((opt) => ({
        ...opt,
        _isSelected: selectedIds.has(opt[this.itemValue])
      }));
    },
    selectedTitle() {
      if (!this.selectedData.length) return '';

      return this.selectedData
        .map((item) => item[this.itemTitle])
        .filter(Boolean)
        .join(', ');
    }
  },
  methods: {
    _normalizeValue(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      return [value];
    },

    _updateSelected(data) {
      let id = data[this.itemValue];
      let exists = this.selectedData.some((selected) => selected[this.itemValue] === id);
      this.selectedData = exists
        ? this.selectedData.filter((sItem) => sItem[this.itemValue] !== id)
        : [...this.selectedData, data];
    },

    onChangeSelect(item) {
      this._updateSelected(item);

      this.$emit('change', this.selectedData);

      setTimeout(() => {
        this.isOpen = false;
      }, 300);
    },
    onAway() {
      this.isOpen = false;
    }
  }
};
